import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";

import { CREATE_GROUP } from "../group.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateGroupInput } from "../../../__generated__/globalTypes";
import {
  CreateGroupMutation,
  CreateGroupMutationVariables,
} from "../../../__generated__/CreateGroupMutation";

interface IProps {
  defaultValues: DeepPartial<CreateGroupInput>;
  onCompleted: () => any;
}

export const useCreateGroup = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateGroupInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateGroupMutation,
    CreateGroupMutationVariables
  >(CREATE_GROUP, {
    refetchQueries: ["GroupsQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createGroup?.ok) {
        onCompleted();
      } else {
        throw Error(data?.createGroup?.error ?? "Error");
      }
    } catch (error) {
      console.log(error);
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
